import { render, staticRenderFns } from "./SortImg.vue?vue&type=template&id=0c81d810&scoped=true"
import script from "./SortImg.vue?vue&type=script&lang=js"
export * from "./SortImg.vue?vue&type=script&lang=js"
import style0 from "./SortImg.vue?vue&type=style&index=0&id=0c81d810&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81d810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c81d810')) {
      api.createRecord('0c81d810', component.options)
    } else {
      api.reload('0c81d810', component.options)
    }
    module.hot.accept("./SortImg.vue?vue&type=template&id=0c81d810&scoped=true", function () {
      api.rerender('0c81d810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore2/modules/SortImg.vue"
export default component.exports